import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import CustomSelect from "../CustomSelect";
import "./titoliStudio.css";

const AddTitoliStudio = () => {
  const [tipologiaTitoli, setTipologiaTitoli] = useState([]);
  const [selectedTipologiaTitoloId, setSelectedTipologiaTitoloId] =
    useState("");

  const [loading, setLoading] = useState(false);
  const [nomeTitolo, setNomeTitolo] = useState("");
  const [rilasciatoIl, setRilasciatoIl] = useState("");
  const [da, setDa] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);

  const isValid = () => {
    const inputErrors = {};
    if (selectedTipologiaTitoloId === "") {
      inputErrors.titoloTipologia = "Devi selezionare una tipologia titolo!";
    }
    if (nomeTitolo.trim() === "") {
      inputErrors.nomeTitolo = "Il campo Nome Titolo non può essere vuoto!";
    }
    if (rilasciatoIl.trim() === "") {
      inputErrors.rilasciatoIl = "Il campo Rilasciato Il non può essere vuoto!";
    }
    if (da.trim() === "") {
      inputErrors.da = "Il campo Da non può essere vuoto!";
    }

    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "TRAINER") {
      alert("Accedi come docente per aggiungere i titoli di studio!");

      localStorage.clear();
      navigate("/login");
    } else {
      setIsAuthorized(true);
      fetchTipologiaTitoli();
    }
  }, [navigate]);

  const fetchTipologiaTitoli = async () => {
    setLoading(true);
    try {
      const response = await api.get("/tipologia-titoli");
      if (response.status === 200) {
        setTipologiaTitoli(response.data);
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const addTipTitolo = async () => {
    if (!isValid()) return;

    try {
      setLoading(true);
      const response = await api.post("/titoli-studio", {
        nomeTitolo,
        rilasciatoIl,
        da,
        idTipologiaTitolo: parseInt(selectedTipologiaTitoloId, 10),
      });

      if (response.status === 200 || response.data?.status === 200) {
        toast.success("Titolo di studio aggiunto con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        navigate("/titoli-studi");
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleNomeTitoloChange = (value) => {
    setNomeTitolo(value);
    if (value.trim() !== "") {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.nomeTitolo;
        return updated;
      });
    }
  };

  const handleRilasciatoIlChange = (value) => {
    setRilasciatoIl(value);
    if (value.trim() !== "") {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.rilasciatoIl;
        return updated;
      });
    }
  };

  const handleDaChange = (value) => {
    setDa(value);
    if (value.trim() !== "") {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.da;
        return updated;
      });
    }
  };

  const handleTipologiaChange = (selected) => {
    const value = selected ? selected.value : "";
    setSelectedTipologiaTitoloId(value);
    if (value !== "") {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.titoloTipologia;
        return updated;
      });
    }
  };

  if (!isAuthorized) return null;

  return (
    <div className="add-titoli-studi-modern-bg">
      {loading && (
        <div className="add-titoli-studi-modern-overlay">
          <div className="add-titoli-studi-modern-spinner"></div>
        </div>
      )}
      <div className="add-titoli-studi-modern-card">
        <div className="add-titoli-studi-modern-header">
          <button
            onClick={() => navigate("/titoli-studi")}
            className="add-titoli-studi-modern-back"
            title="Torna indietro"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <h2>
            <i className="fa-solid fa-graduation-cap"></i>
            Aggiungi Titolo di Studio
          </h2>
        </div>
        <form
          className="add-titoli-studi-modern-form"
          onSubmit={(e) => {
            e.preventDefault();
            addTipTitolo();
          }}
        >
          <div className="add-titoli-studi-modern-fields">
            <div className="add-titoli-studi-modern-field">
              <label className="add-titoli-studi-modern-label">
                <i className="fa-solid fa-layer-group"></i>
                Tipologia Titolo
              </label>
              <CustomSelect
                options={tipologiaTitoli.map((titolo) => ({
                  value: titolo.idTipologiaTitolo,
                  label:
                    titolo.titoloTipologia ||
                    `Titolo ${titolo.idTipologiaTitolo}`,
                }))}
                value={
                  selectedTipologiaTitoloId
                    ? {
                        value: selectedTipologiaTitoloId,
                        label:
                          tipologiaTitoli.find(
                            (t) =>
                              t.idTipologiaTitolo === selectedTipologiaTitoloId
                          )?.titoloTipologia ||
                          `Titolo ${selectedTipologiaTitoloId}`,
                      }
                    : null
                }
                onChange={handleTipologiaChange}
                placeholder="Seleziona una tipologia titolo"
              />
              {errors.titoloTipologia && (
                <span className="add-titoli-studi-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.titoloTipologia}
                </span>
              )}
            </div>
            <div className="add-titoli-studi-modern-field">
              <label className="add-titoli-studi-modern-label">
                <i className="fa-solid fa-certificate"></i>
                Nome Titolo
              </label>
              <input
                type="text"
                value={nomeTitolo}
                onChange={(e) => handleNomeTitoloChange(e.target.value)}
                id="nomeTitolo"
                placeholder="Nome Titolo"
                className={errors.nomeTitolo ? "error" : ""}
              />
              {errors.nomeTitolo && (
                <span className="add-titoli-studi-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.nomeTitolo}
                </span>
              )}
            </div>
            <div className="add-titoli-studi-modern-field">
              <label className="add-titoli-studi-modern-label">
                <i className="fa-solid fa-calendar-plus"></i>
                Rilasciato Il
              </label>
              <input
                type="date"
                value={rilasciatoIl}
                onChange={(e) => handleRilasciatoIlChange(e.target.value)}
                id="rilasciatoIl"
                placeholder="es. 2022-07-15"
                className={errors.rilasciatoIl ? "error" : ""}
              />
              {errors.rilasciatoIl && (
                <span className="add-titoli-studi-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.rilasciatoIl}
                </span>
              )}
            </div>
            <div className="add-titoli-studi-modern-field">
              <label className="add-titoli-studi-modern-label">
                <i className="fa-solid fa-building-columns"></i>
                Da
              </label>
              <input
                type="text"
                value={da}
                onChange={(e) => handleDaChange(e.target.value)}
                id="da"
                placeholder="Ente o istituto di rilascio"
                className={errors.da ? "error" : ""}
              />
              {errors.da && (
                <span className="add-titoli-studi-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.da}
                </span>
              )}
            </div>
          </div>
          <div className="add-titoli-studi-modern-actions">
            <button
              type="button"
              className="add-titoli-studi-modern-cancel"
              onClick={() => navigate("/titoli-studi")}
            >
              <i className="fa-solid fa-times"></i>
              Annulla
            </button>
            <button type="submit" className="add-titoli-studi-modern-save">
              <i className="fa-solid fa-plus"></i>
              Aggiungi
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTitoliStudio;
